import { useState } from 'react'
import textServices from 'services/text-services'
import { dlTrackEvent } from 'components/dataLayer/dataLayer'
import { F1GalleryPhoto, F1_RANKING_PAGE_SIZE, photoDisplayName } from '../gallery'
import { F1_CAMPAIGN_CLOSED } from '../constants'
import StarIcon from './StarIcon'

interface RankingSectionProps {
  ranking: F1GalleryPhoto[]
}

// Likes ranking (Figma 5411:5037 compressed / 5417:10273 expanded): starts
// collapsed behind the "¡Quiero ver el ranking!" CTA, then lists photos by
// votes six at a time with a "Mostrar más" loader. The photo-upload dynamic
// is closed, so the expanded state has no participate CTA. Once the campaign
// is closed (Figma 6178:5489) the list opens expanded with no CTA at all.
const RankingSection = ({ ranking }: RankingSectionProps) => {
  const [expanded, setExpanded] = useState(F1_CAMPAIGN_CLOSED)
  const [shown, setShown] = useState(F1_RANKING_PAGE_SIZE)

  const visible = ranking.slice(0, shown)
  const hasMore = shown < ranking.length

  return (
    <section className="pitstops__ranking">
      <h2 className="pitstops__ranking-title">
        {textServices.findByText('pitstops/ranking/title', 'Ranking de likes')}
      </h2>
      <p className="pitstops__ranking-text">
        {textServices.findByText(
          'pitstops/ranking/text',
          'Descubre tu lugar en la tabla de posiciones y sigue de cerca a quienes lideran la carrera. '
        )}
        <strong>
          {textServices.findByText(
            'pitstops/ranking/textBold',
            'Las fotos con más votos al final de la competencia serán las ganadoras.'
          )}
        </strong>
      </p>

      {!expanded ? (
        <button
          type="button"
          className="home-v3__button pitstops__cta pitstops__ranking-cta"
          onClick={() => {
            dlTrackEvent('user_interaction', {
              action: 'click',
              element: 'ranking :: ver ranking',
              section: 'pitstops'
            })
            setExpanded(true)
          }}
        >
          {textServices.findByText('pitstops/ranking/viewCta', '¡Quiero ver el ranking!')}
        </button>
      ) : (
        <>
          <ol className="pitstops__ranking-list">
            {visible.map((photo, index) => (
              <li
                key={photo.id}
                className={`pitstops__ranking-row${index === 0 ? ' pitstops__ranking-row--leader' : ''}`}
              >
                <span className="pitstops__ranking-position">{index + 1}</span>
                <span className="pitstops__ranking-identity">
                  {photoDisplayName(photo) ? (
                    <>
                      <span className="pitstops__ranking-name">{photoDisplayName(photo)}</span>
                      <span className="pitstops__ranking-code">ID° {photo.code}</span>
                    </>
                  ) : (
                    <span className="pitstops__ranking-name">ID° {photo.code}</span>
                  )}
                </span>
                <span className="pitstops__ranking-votes">
                  <StarIcon className="pitstops__ranking-star" /> {photo.votes}
                </span>
              </li>
            ))}
          </ol>
          {hasMore && (
            <button
              type="button"
              className="pitstops__ranking-more"
              onClick={() => {
                dlTrackEvent('user_interaction', {
                  action: 'click',
                  element: 'ranking :: mostrar mas',
                  section: 'pitstops'
                })
                setShown((current) => current + F1_RANKING_PAGE_SIZE)
              }}
            >
              <span className="pitstops__ranking-more-icon" aria-hidden="true">
                +
              </span>{' '}
              {textServices.findByText('pitstops/ranking/moreCta', 'Mostrar más')}
            </button>
          )}
        </>
      )}
    </section>
  )
}

export default RankingSection
